import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SbManagerRoutingModule } from './sb-manager-routing.module';
import { SbWorkflowsComponent } from './sb-workflows/sb-workflows.component';
import { SbListComponent } from './sb-list/sb-list.component';
import { SbEditorModule } from './sb-editor/sb-editor.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SbWorkflowsComponent, SbListComponent],
  imports: [SbEditorModule, CommonModule, FormsModule, SbManagerRoutingModule, TranslateModule],
  exports: [SbWorkflowsComponent, SbListComponent],
})
export class SbManagerModule {}
